import CalendarEventKey from 'mini-calendar-event-types/lib/CalendarEventKey';
import { action } from 'satcheljs';
import { OwaDate } from 'owa-datetime';

/**
 * Action to notify to trigger loading of day view.
 */
export const loadDayView = action(
    'loadDayView',
    (pivotDate?: OwaDate, eventsAddedOrRemoved?: CalendarEventKey[]) => ({
        pivotDate,
        eventsAddedOrRemoved,
    })
);

/**
 * Action to reset the day view store.
 */
export const resetDayViewStore = action('resetDayViewStore');

/**
 * This action is fired when day view is scrolled.
 */
export const onDayViewScroll = action('ON_DAY_VIEW_SCROLL');

/**
 * This action is fired when day view is swiped.
 */
export const onDayViewDateChanged = action('ON_DAY_VIEW_DATE_CHANGED', (newDate: OwaDate) => ({
    newDate,
}));

/**
 * This action is fired when all day view is expanded/collapsed.
 */
export const onAllDayViewExpandCollapse = action(
    'ON_ALL_DAY_VIEW_EXPAND_COLLAPSE',
    (isExpanded: boolean) => ({
        isExpanded,
    })
);

/**
 * This action is fired when loading events has started or completed
 */
export const onDayViewLoadingStatusChanged = action(
    'ON_DV_LOAD_IN_PROGRESS',
    (isLoading: boolean) => ({ isLoading })
);
